import type { BadgeTone } from '../../components/Badge';
import type { BackupStatus } from './api';

/**
 * Die Darstellung der Sicherungszustaende -- F5-01, Anforderung 2.
 *
 * **``completed_with_errors`` ist gelb und nicht gruen.** Das ist die eine
 * Festlegung, die diese Datei zu treffen hat, und sie ist der Kern der
 * Anforderung: Cove meldet den Fall als "Completed" mit Fehlerzahl groesser
 * null. Wer ihn gruen faerbt, hat eine Uebersicht gebaut, die genau dort
 * schweigt, wo sie sprechen soll.
 *
 * **``unknown`` ist ebenfalls nicht gruen.** Ein Geraet ohne Ergebnis ist
 * kein Geraet in Ordnung. Es ist eines, von dem niemand etwas weiss -- und
 * das ist im Zweifel schlechter als ein bekannter Fehler.
 *
 * **Die Farbe traegt die Aussage nie allein.** Jede Zeile nennt den Zustand
 * als Wort und die Fehlerzahl als Zahl; das Kennzeichen ist die Abkuerzung
 * fuer den Blick, nicht die Auskunft.
 */
export const STATUS_TONES: Record<BackupStatus, BadgeTone> = {
  failed: 'danger',
  completed_with_errors: 'warning',
  unknown: 'warning',
  in_process: 'info',
  completed: 'success',
};

/** Ob ein Zustand als Fehler zaehlt -- deckungsgleich mit ``FAILING_STATUSES``. */
export function isFailing(status: BackupStatus): boolean {
  return status === 'failed' || status === 'completed_with_errors';
}

/**
 * Belegter Speicher, lesbar.
 *
 * Binaerpraefixe (1024), weil der Anbieter so rechnet -- eine Anzeige, die
 * andere Zahlen nennt als die Oberflaeche des Anbieters daneben, kostet mehr
 * Zeit, als sie an Genauigkeit gewinnt.
 */
export function formatBytes(bytes: number | null | undefined, locale: string): string | null {
  if (bytes === null || bytes === undefined) return null;

  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toLocaleString(locale, { maximumFractionDigits: value < 10 ? 1 : 0 })} ${units[unit]}`;
}
